export default {
  hasData: (state) => state.overview !== null && !state.isFirstLoad,
  isEmpty: (state) => {
    if (!state.overview) return true
    const o = state.overview
    return (o.attendance && o.attendance.total_attended === 0) && state.timeline.length === 0
  },
  // Formata "atualizado há Xs" — recalculado quando o componente atualiza um relógio interno
  freshnessSeconds: (state) => {
    if (!state.lastUpdate) return null
    return Math.floor((Date.now() - state.lastUpdate.getTime()) / 1000)
  }
}
